export const COW_TABLE_COLUMNS = [
  'registrationNumber',
  'earNumber',
  'name',
  'dateOfBirth',
  'ageInMonths',
  'hipHeight',
  'bcs',
] as const;

export const MEASUREMENT_FORM = {
  HIP_HEIGHT: 'hipHeight',
  BODY_CONDITION_SCORE: 'bodyConditionScore',
  MEASUREMENT_DATE: 'measurementDate',
} as const;
